import {Editor, Extension} from '@tiptap/core'
import TipTapCoreLoader from "../internals/TipTapCoreLoader";

interface TipTapImport {
    Editor: typeof Editor,
    StarterKit: any,
    Underline: any,
    TextAlign: any,

    Table: any,
    TableRow: any,
    TableCell: any,
    TableHeader: any,
    Link: any,
    YouTube: any,
    Mention: any,
    Suggestion: any
}

export default class TipTapEditorLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<TipTapImport>;

    private static instance: TipTapImport;

    public static load(): Promise<TipTapImport> {
        if (TipTapEditorLoader.status == 0) {
            TipTapEditorLoader.status = 1;


            TipTapEditorLoader.promise = Promise.all([

                import(/* webpackChunkName: "tiptap-css" */ './style/tiptap-editor.css'),

                TipTapCoreLoader.load(),

                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/starter-kit'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-underline'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-text-align'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-table'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-table-row'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-table-cell'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-table-header'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-link'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-youtube'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/suggestion'),
                import(/* webpackMode: "lazy-once", webpackChunkName: "tiptap-editor" */ '@tiptap/extension-mention'),

            ]).then(v => {
                console.log("TIP TAP LOADER", v);

                let core = v[1];
                let starterKit = v[2];
                let underline = v[3];
                let textalign = v[4];
                let table = v[5];
                let tableRow = v[6];
                let tableCell = v[7];
                let tableHeader = v[8];
                let link = v[9];
                let youtube = v[10];
                let sugg = v[11];
                let mention = v[12];

                let exp = {
                    Editor: core.Editor,
                    StarterKit: starterKit.default,
                    Underline: underline.default,
                    TextAlign: textalign.default,

                    Table: table.default,
                    TableRow: tableRow.default,
                    TableCell: tableCell.default,
                    TableHeader: tableHeader.default,
                    Link: link.default,
                    YouTube: youtube.default,
                    Mention: mention.default,
                    Suggestion: sugg.default
                } as unknown as TipTapImport;

                TipTapEditorLoader.instance = exp;
                TipTapEditorLoader.status = 2;

                return exp;

            });


            return TipTapEditorLoader.promise;
        } else if (TipTapEditorLoader.status == 1) {
            return TipTapEditorLoader.promise;
        } else {
            return Promise.resolve(TipTapEditorLoader.instance);
        }
    }

}